/*
 * @Date: 2021-11-29 15:51:46
 * @LastEditTime: 2021-11-30 15:50:09
 * @Description: qiankun所用到的接口集合
 */

import Request from '../../utils/request'

export const QiankunServer = {
  /** 首页的组件化独立接口
   * @link https://gitlab.weike.fm/oc/oc-docs/-/blob/master/operating/活动文档/首页新增模块.md#6首页组件模块接口
   */
  getActivityInfo(params: { activity_id?: number }) {
    return Request.$get('/operating/api/lego', { params })
  },
  /** 活动预览 */
  preview(params: { version_detail_id: number; activity_id?: number | string }) {
    return Request.$get(`/operating/api/components/preview`, { params })
  }
}

export default QiankunServer

// tslint:disable-next-line:no-namespace
export declare namespace IskinActivity {
  interface ShareInfo {
    url: string
    source: string
    share_icon: string
    share_title: string
    share_description: string
  }

  interface Global {
    inviter_id: string
    project?: string
    share_info: ShareInfo
  }

  interface Source {
    /** 数据id */
    _id: number
    /** 数据源名称（用于ui展示） */
    name: string
    /** 数据源source */
    _name: string
    /** 后台用的sourceKey */
    dataSourceKey: string
    __value: any[] // 将details[item]扔到__value里面去
    /** 后端需要的标识 */
    _kind_: string
  }

  interface CmpSource {
    _kind_: string
    _source_: Source[]
    details: any[]
  }

  interface Component {
    [x: string]: CmpSource
  }

  interface ActivityData {
    global: Global
    components: Component[]
  }

  interface RootObject {
    id: number
    activity_type: string
    activity_name: string
    activity_data: ActivityData
    new_activity: boolean
    page_type: string
    contents: IskinContents.RootObject
  }
}

// tslint:disable-next-line:no-namespace
export declare namespace IskinContents {
  interface Layout {
    key: string
    name: string
    show: string[]
    cmpName: string
  }

  interface Option {
    id: string
    key: string
    name: string
    type: string
    index: number
    value: string
    layout: Layout[]
    cmpName: string
    required: boolean
    extra: {
      priority: number
    }
    show: string[]
    components: Component[]
    dataSources: DataSource[]
  }

  interface Component {
    handle?: {
      action: string
      type: string
      value: string
    }
    key: string
    name: string
    type: string
    value: any
    cmpName: string
    required: boolean
    layout: Layout[]
    show: string[]
    components: Component[]
    /** 旧版数据，新版本已经去掉，这里做兼容处理 */
    subProps?: Component[]
    animate?: boolean
  }

  interface Source {
    key: string
    name: string
    dataSourceKey: string
    type: string
  }

  interface DataCmp {
    key: string
    name: string
    show: string[]
    source: Source[]
    cmpName: string
  }

  interface DataSource {
    key: string
    name: string
    type: string
    value: string
    cmpName: string
    dataCmp: DataCmp[]
  }

  interface Combinations {
    version: string
    global: Option[]
    option: Option[]
  }

  interface RootObject {
    id: number
    version: number
    version_name: string
    online: boolean
    combinations: Combinations
  }
}



// WEBPACK FOOTER //
// ./src/services/Modules/qiankunServer.ts